import externalAppConfig from '../stores/ExternalApp/externalAppConfig';
import ExternalAppStore from '../stores/ExternalApp/ExternalAppStore';

export default function windowTopZero(): number {
  if (externalAppConfig?.customTitleBar) {
    const titleBarHeight = ExternalAppStore.getCustomTitleBarHeight();
    return isNaN(titleBarHeight) ? 0 : titleBarHeight;
  }

  return 0;
}